<template>
<div v-if="dataCenter" :class="`data-center data-center--${dataCenter.name.toLowerCase().replace(' ', '-')}`">
    
  <v-tooltip target="dataCenterName"
            :content="`Click to toggle IP address`"
            :delay="500">
  </v-tooltip>

  <span :class="`data-center__name data-center--${dataCenter.status.toLowerCase()}`">
    <span ref="dataCenterName" @click.prevent="showIPAddress = !showIPAddress">
      <transition name="fade" mode="out-in">
        <span v-if="showIPAddress" 
              class="text" 
              key="ip_address">
                {{ dataCenter.ip_address }}
        </span>
        <span v-else 
              class="text" 
              key="name">
                {{ dataCenter.name }}
        </span>
      </transition>
    </span>
  </span>

  <div :class="`data-center__servers data-center__servers--${dataCenter.name.toLowerCase().replace(' ', '-')}`">
    <server v-for="(server, index) in servers" 
            :key="index" 
            :server="server">
    </server>
  </div>
</div>
</template>

<script>
import Server from './Server'
import VTooltip from './../components/Tooltip'

export default {
  components: {
    Server,
    VTooltip
  },

  props: {
    'dataCenter': {
      type: Object
    },
    'servers': {
      type: Array
    }
  },

  data() {
    return {
      showIPAddress: false
    }
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.data-center {
  position: relative;
  margin: 0 em(10px);
  padding-bottom: em(10px);
  background-color: $color-dark-1;
  width: em(300px);
  max-width: em(300px);
}

.data-center--offline {
  border-color: $color-offline !important;
}

.data-center--online {
  border-color: $color-online !important;
}

.data-center__name {
  display: block;
  padding: em(10px);
  background-color: $color-dark-1;
  font-family: $font-roboto;
  text-align: center;
  border-bottom: em(5px) solid $color-dark-1;
  border-color: $color-dark-1;
  transition: border-color 2s ease;

  .text {
    font-size: em(18px);
    cursor: pointer;
  }
}

.data-center__servers {
  position: relative;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>